import { initializeApp, getApps } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectStorageEmulator, getStorage } from "firebase/storage";

import { firebaseConfig } from "./config";

const firebaseApp =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
const auth = getAuth(firebaseApp);

// Initialize Firestore with default database
const db = getFirestore(firebaseApp);

const storage = getStorage(firebaseApp);

// Connect to emulators in development and test environments
// Note: NODE_ENV is "development" when running `next dev`, even in test mode
// So we use NEXT_PUBLIC_* env vars to explicitly set emulator ports
if (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test") {
  // Use explicit ports from NEXT_PUBLIC_* env vars if set (from TUI script or App Hosting emulator)
  // Otherwise fall back to detecting based on NODE_ENV (legacy behavior)
  // Note: When App Hosting emulator runs on test config (port 5004), we use test ports (8081, 9098, 9198)
  // The App Hosting emulator should auto-inject these, but if not, try test ports first
  const isTestMode =
    process.env.NODE_ENV === "test" ||
    process.env.PLAYWRIGHT_TEST === "1" ||
    (typeof window !== "undefined" && window.location.port === "5004");

  const ports = {
    firestore: process.env.NEXT_PUBLIC_FIRESTORE_EMULATOR_PORT
      ? parseInt(process.env.NEXT_PUBLIC_FIRESTORE_EMULATOR_PORT, 10)
      : isTestMode
        ? 8081
        : 8080,
    auth: process.env.NEXT_PUBLIC_FIREBASE_AUTH_EMULATOR_PORT
      ? parseInt(process.env.NEXT_PUBLIC_FIREBASE_AUTH_EMULATOR_PORT, 10)
      : isTestMode
        ? 9098
        : 9099,
    storage: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_EMULATOR_PORT
      ? parseInt(process.env.NEXT_PUBLIC_FIREBASE_STORAGE_EMULATOR_PORT, 10)
      : isTestMode
        ? 9198
        : 9199,
  };

  try {
    connectAuthEmulator(auth, `http://127.0.0.1:${ports.auth}`, {
      disableWarnings: true,
    });
  } catch {
    // Emulator already connected (happens on hot reload)
  }

  try {
    connectFirestoreEmulator(db, "127.0.0.1", ports.firestore);
  } catch {
    // Emulator already connected (happens on hot reload)
  }

  try {
    connectStorageEmulator(storage, "127.0.0.1", ports.storage);
  } catch {
    // Emulator already connected (happens on hot reload)
  }
}

export { firebaseApp as app, auth, db, storage };
